module.exports = __webpack_public_path__ + "img/CoreGuide.20d1cd41.png";